export const DocumentTypes = {
  JPG: 'IMAGE',
  JPEG: 'IMAGE',
  PNG: 'IMAGE',
  PDF: 'DOCUMENT',
  MOV: 'VIDEO',
  MP4: 'VIDEO',
  MP3: 'AUDIO',
  WAV: 'AUDIO',
  '3GP': 'VIDEO'
}
